
export const OPTION_INPUT_TYPES={
    NEW_LINE:"newLine",
    TRANSFER_LINE:"niudLine",
    CHANGE_PACKAGE:"changePackage",
  };

  export const PROGRAM_STEPS={
    MAIN:"main",
    NEW_LINE_SHOW_SALE_PACKAGES:"newLineShowSalePackages",
    TRANSFER_LINE_SUCCESS:"transferLineSuccess",
    TRANSFER_LINE_CAPACITY_FAILURE:"transferLineCapacityFailure",
    TRANSFER_LINE_ML_FAILURE:"transferLineMLFailure",
    SHOW_CELLULAR_PACKAGES:"showCellularPackages",
  };

  export const orgFamilyMembersSalePages =
  {
    "transferLineCapacityFailure":0,
    "transferLineMlFailure":0,
    "main":12,
    "newLineShowSalePackages":12,
    "showCellularPackages":12,
    "transferLineSuccess":100,
  };

  export const pathHistory={
    main:'main-page',
    transferLineSuccess:"transfer-line-success",
    transferLineCapacityFailure: 'transfer-line-capacity-failure',
    transferLineMlFailure: 'transfer-line-ml-failure',
    showCellularPackages: 'show-cellular-packages',
  }
